import { FC, useMemo } from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

import { getStatusLabel } from 'src/utils/utility';
import { IInternalDashboardHeaderProps } from './types';
import { FieldResolutionStatus } from './FieldResolutionStatus';
import { useInternalDashboardSelector } from './Selector';

const StyledBox = styled(Box)({
  '& .MuiFormControl-root': {
    width: '210px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
});

export const InternalDashboardHeader: FC<IInternalDashboardHeaderProps> = ({ items, isLoading }) => {
  const { filterParams, setFilterStatuses, resolvedStatuses, unresolvedStatuses } = useInternalDashboardSelector();

  const statusOptions = useMemo(() => {
    const items = [];

    if (unresolvedStatuses && unresolvedStatuses?.length > 0) {
      items.push({
        isLabel: true,
        label: 'UNRESOLVED',
        value: 'UNRESOLVED',
      });
      unresolvedStatuses.forEach((item) => {
        items.push({
          isLabel: false,
          label: getStatusLabel(item),
          value: item,
        });
      });
    }
    if (resolvedStatuses && resolvedStatuses?.length > 0) {
      items.push({
        isLabel: true,
        label: 'RESOLVED',
        value: 'RESOLVED',
      });
      resolvedStatuses.forEach((item) => {
        items.push({
          isLabel: false,
          label: getStatusLabel(item),
          value: item,
        });
      });
    }
    return items;
  }, [resolvedStatuses, unresolvedStatuses]);

  return (
    <div className='sticky top-0 flex items-center gap-20 px-24 pt-24 pb-20 bg-white border-b border-neutral-20 mb-20 z-10'>
      <h2 className='text-20 font-bold text-blue_grey-80 max-lg:text-18'>Overview</h2>

      <div className='ml-auto flex items-center gap-16'>
        <div>
          <StyledBox>
            <FieldResolutionStatus
              defaultValue={filterParams?.fileResolutionStatuses || []}
              options={statusOptions}
              onChange={(values) => setFilterStatuses(values)}
            />
          </StyledBox>
        </div>
      </div>
    </div>
  );
};
